import * as React from "react";
import { navigate } from "~/router";
import { Overlay, SideModal, SideModalContent } from "~/common/layout/Modals";
import Head from "~/common/layout/Head";
import ProductSegmentForm from "../../components/products/ProductSegmentForm";
import { useEditProductGroup, useProductGroupById } from "~/apps/pos/apis/productGroups";
import { ProductSegmentReq } from "~/apps/pos/models";

const ProductGroupEditPopup = ({ groupId }) => {
  const { data: group, isLoading: getGroupLoading } = useProductGroupById(groupId);
  const { mutate: onEdit, error, isLoading: editGroupLoading } = useEditProductGroup();

  const handleClose = () => {
    navigate("pos.admin.products.groups");
  };

  const handleSubmit = (data: ProductSegmentReq) => {
    onEdit(data, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const initialValues = {
    id: group?.id || "",
    name: group?.name || "",
  };

  return (
    <Overlay onClick={handleClose} isLoading={getGroupLoading || editGroupLoading}>
      <SideModal>
        <Head headTitle={`Edit group - ${group?.name}`} />
        <SideModalContent>
          <ProductSegmentForm
            initialValues={initialValues}
            error={error?.message || error?.errorMessage || ""}
            onSubmit={handleSubmit}
            onClose={handleClose}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};

export default ProductGroupEditPopup;
